module.exports = __webpack_public_path__ + "static/media/edit.f49e2b0f.svg";